export default function(index) {
    // index == 0 current billing cycle
    // index < 0 previous biling cucle
    // index > 1 future billing cycle
   var now = new Date()
   
   var startOfMonth = now.getDate() >= 26
       ? new Date(now.getFullYear(), now.getMonth() + index, 26)
       : new Date(now.getFullYear(), now.getMonth() - 1 + index, 26)
   
    var endOfMonth = new Date(startOfMonth.getFullYear(), startOfMonth.getMonth() + 1, 25);
    return {from: startOfMonth, to: endOfMonth}
}